export class LoginModel {
    email: string | undefined;
    password: string | undefined;
    rememberMe: boolean | undefined;
}